import { getLocalStorage, setLocalStorage } from '@efe-activity-fe-util/core'
import {
    ALL_GP_SELECTOR,
    ALL_IOS_SELECTOR,
    ROLE_POPUP_HOST_SELECTOR,
    SHOP_PRE_POPUP_SELECTOR,
} from '../constants/selector'
import {
    POPUP_FROM_MANDATORY,
    POPUP_FROM_SCROLL,
    POPUP_FROM_SET,
    POPUP_FROM_THIRTY_SECONDS,
} from '../constants/trackClass'
import Config from '../libs/config.json'
import { usePopup } from '../hooks/usePopup'

const { gameCode, activityCode } = Config
const preStatusKey = `${gameCode}_${activityCode}_pre_status`
const FORCE_OPEN_PRE_POPUP_DELAY = 20 * 1000

const { openPopup, closePopupAll } = usePopup()

export async function bootstrap() {
    bindEvent()
}

export function getPreStatus() {
    return !!getLocalStorage(preStatusKey)
}

export function setPreStatus() {
    setLocalStorage(preStatusKey, 1)
}

function bindEvent() {
    // forceOpenPrePopup(0, POPUP_FROM_MANDATORY)
    forceOpenPrePopup(FORCE_OPEN_PRE_POPUP_DELAY, POPUP_FROM_THIRTY_SECONDS)
    scrollOpenPopup(ROLE_POPUP_HOST_SELECTOR)
    $(`${ALL_GP_SELECTOR}, ${ALL_IOS_SELECTOR}`).on('click', () => {
        closePopupAll()
        setPreStatus()
    })
}

function forceOpenPrePopup(
    time: number = FORCE_OPEN_PRE_POPUP_DELAY,
    trackClass?: string
) {
    window.setTimeout(() => {
        if (getPreStatus() || hasOpenedPopup()) {
            return
        }

        openPrePopup(trackClass)
    }, time)
}

function openPrePopup(sourceClass?: string) {
    if (!$(SHOP_PRE_POPUP_SELECTOR).length) {
        return
    }

    closePopupAll()
    setPrePopupSource(sourceClass)
    openPopup(SHOP_PRE_POPUP_SELECTOR)
}

function setPrePopupSource(sourceClass?: string) {
    $(SHOP_PRE_POPUP_SELECTOR)
        .removeClass(POPUP_FROM_SET.join(' '))
        .addClass(sourceClass)
}

function hasOpenedPopup() {
    return $('.popup-panel:visible').length > 0
}

function scrollOpenPopup(selector: string) {
    if (getPreStatus()) {
        return
    }

    const el = document.querySelector(selector)

    if (!el) {
        return
    }

    let last = 0
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (getPreStatus() || last > 0) {
                observer.disconnect()
                return
            }

            const now = Date.now()

            if (!entry.isIntersecting || now - last < 0 || hasOpenedPopup()) {
                return
            }

            openPrePopup(POPUP_FROM_SCROLL)
            last = now
        },
        { threshold: 0.5 }
    )
    observer.observe(el)
}
